export function isLocalVideoTrack(track) {
    // This doesn't seem like the best way to determine this. I'd rather have an explicit isLocal() method or something,
    // but I'm not going to mess with it right now - JG
    return track.restart !== undefined;
}
//# sourceMappingURL=guards.js.map